// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tkn3","left":"styles_left__233ga"};